/**
 * De lijst met stellingen, links in het tabblad Stellingen -- van de
 * beheerder (die mag toevoegen en verwijderen) en van de leerkracht (die
 * alleen kiest). Wat er rechts staat als er een stelling gekozen is,
 * verschilt per scherm en staat daar. Wat als `children` meekomt (een
 * formulier voor een nieuwe stelling) staat tussen de kop en de lijst.
 */
import React from 'react';
import { Trash2 } from 'lucide-react';
import { gedeeld } from '../theme/stijlen';

export function StellingenLijst({ titel, stellingen, laden, geselecteerdId, onKies, onVerwijder, knop, leegTekst, stijlen, children }) {
  const s = { ...gedeeld, ...stijlen };
  return (
    <div style={s.listPanel}>
      <div style={s.panelHeader}>
        <h2>{titel}</h2>
        {knop}
      </div>
      {children}
      {laden ? <p>Laden...</p> : stellingen.length === 0 ? <p style={s.empty}>{leegTekst}</p> : (
        <ul style={s.list}>
          {stellingen.map((stelling) => (
            <li key={stelling.id} style={geselecteerdId === stelling.id ? s.listItemActive : s.listItem} onClick={() => onKies(stelling.id)}>
              <span>{stelling.titel}</span>
              {onVerwijder && (
                <button onClick={(e) => { e.stopPropagation(); onVerwijder(stelling.id); }} style={s.deleteBtn}><Trash2 size={16} /></button>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
